import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview, trackEvent } from '../utils/analytics.js';

/**
 * Hook personnalisé pour suivre automatiquement les vues de pages et les changements d'onglets
 *
 * @param {Object} options - Options de configuration
 * @param {Object} options.currentUser - L'utilisateur connecté (facultatif)
 * @param {string} options.project - Le projet actif (facultatif)
 */
export default function useAnalytics(options = {}) {
  const location = useLocation();
  const { pathname } = location;
  const { currentUser, project, module } = options;

  // Suivi des changements de pages (sans le hash)
  useEffect(() => {
    let props = {};

    // Ajouter les infos d'utilisateur si disponibles
    if (currentUser) {
      props = {
        ...props,
        user: currentUser.username,
        client: currentUser.client,
        isAdmin: currentUser.isadmin || currentUser.issuperadmin
      };
    }

    if (module) {
      props = {
        ...props,
        module: module
      };
    }

    if (project) {
      props = {
        ...props,
        project: project
      };
    }

    try {
      trackPageview({
        url: pathname,
      }, { props });
    } catch (error) {}
  }, [pathname, currentUser, project]);

  const track = (eventName, props) => {

    if (currentUser) {
      props = {
        ...props,
        user: currentUser?.username,
        client: currentUser?.client,
      };
    }

    if (project) {
      props = {
        ...props,
        project: project
      };
    }

    try {
      trackEvent(eventName, { props });
    } catch (error) {}
  };

  // Pas besoin de retourner quoi que ce soit, le hook s'occupe du tracking en arrière-plan
  return { track };
}